import React from 'react';
import PropTypes from 'prop-types';

import Track from './track';

class Song extends React.Component {
  isCurrentSong = () => this.props.current.song === this.props.index;
  isInProgress = () => this.props.current.inProgress && this.isCurrentSong();
  isCollapsed = () => this.props.current.collapsed === this.props.index;
  isSingleTrack = () => this.props.track;
  getNextTrack = () => (this.props.tracks || [this.props.track]).find(track => !track.duration || track.progress < track.duration);
  toggleCollapse = () => this.props.onCollapse(this.isCollapsed() ? null : this.props.index);
  clickOnName = () => this.props.toggleListening(this.isCollapsed() ? null : this.props.index);
  clickOnPlay = () => {
    if (this.isInProgress()) {
      if (this.isSingleTrack())
        this.props.toggleListening(this.props.index, this.getNextTrack(), false)
      else
        this.props.toggleListening(this.props.index)
    } else if (this.getNextTrack()) {
      this.props.toggleListening(this.props.index, this.getNextTrack())
    } else {
      this.props.replay(this.props.index, this.props.track);
    }
  }
  songStateIcon = () => {
    if (this.isInProgress()) {
      return "pause";
    } else if (this.getNextTrack()) {
      return "play";
    } else {
      return "undo-alt";
    }
  }
  calcProgressBarWidth = () => {
    if (this.props.track) {
      let duration = this.props.track.duration;
      let progression = this.props.track.progress || 0;
          progression = progression > duration ? duration : progression;

      if (progression && duration) {
        return `${progression * 100 / duration}%`
      } else {
        return 0;
      }
    } else {
      let duration = this.props.current.duration;
      let progression = this.props.current.progress || 0;
          progression = progression > duration ? duration : progression;

      const completedTracks = this.props.tracks.filter(track => track.progress && track.progress >= track.duration).length;
      let trackProgression = 0;
      if (this.isInProgress() && duration) {
        trackProgression = progression / duration;
      }
      return `${(completedTracks + trackProgression) * 100 / this.props.tracks.length}%`
    }
  }
  formatTime = time => {
    // Hours, minutes and seconds
    var hrs = ~~(time / 3600);
    var mins = ~~((time % 3600) / 60);
    var secs = ~~time % 60;

    // Output like "1:01" or "4:03:59" or "123:03:59"
    var ret = "";
    if (hrs > 0) {
        ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
    }
    ret += "" + mins + ":" + (secs < 10 ? "0" : "");
    ret += "" + secs;
    return ret;
  }
  setCurrentTime = event => {
    const rect = event.target.getBoundingClientRect();
    const x = event.clientX - rect.left; //x position within the element.
    const duration = this.props.track.duration;
    const time = x * duration / rect.width;
    this.props.setCurrentTime(time);
  }

  render() {
    return (
      <li className="my-1" onClick={() => this.toggleCollapse()}>
        <div className={`flex ${this.isSingleTrack() ? '' : 'flex-wrap'} items-center group cursor-pointer`}>
          {
            this.props.index && (
              <span className="text-grey w-6 font-semibold">{this.props.index}.</span>
            )
          }
          <button type="button" className={`bg-${this.isCurrentSong() ? 'white' : 'grey'} rounded-full h-6 w-6 text-xs text-center transition duration-100 group-hover:bg-white`} onClick={
            event => {
              event.stopPropagation();
              this.clickOnPlay();
            }
          }>
            <i className={`fas fa-${this.songStateIcon()}`} style={{ marginLeft: this.songStateIcon() === "play" ? "2px" : "" }}></i>
          </button>
          <span className={`text-white font-semibold py-1 px-3 ${this.isSingleTrack() ? 'flex-1' : ''}`} onClick={
            event => {
              event.stopPropagation();
              this.clickOnName();
            }
          }>
            {this.props.children && this.props.children}
          </span>
          { !this.isSingleTrack() && (
            <span className={`border-${this.isCollapsed() ? 'white border-b-2' : 'grey border-b'} border-opacity-50 flex-1 relative`}>
              <span className="absolute inset-0 bg-success z-0 transition duration-100 max-w-full" style={{ width: this.calcProgressBarWidth(), height: "2px" }}></span>
            </span>
          ) }
          { this.props.tracks && (
            <button type="button" className="text-white py-1 px-5 -mr-5">
              <i className={`fas fa-chevron-${this.isCollapsed() ? "down" : "right"}`}></i>
            </button>
          ) }
        </div>
        {
          this.isSingleTrack() && this.isCollapsed() && (
            <div className="py-3 mb-6 cursor-pointer" onClick={this.setCurrentTime}>
              <div className={`border-white border-b-2 border-opacity-50 flex-1 relative`}>
                <span className="absolute inset-0 bg-success z-0 transition duration-100 max-w-full pointer-events-none" style={{ width: this.calcProgressBarWidth(), height: "2px" }}></span>
                <span className="absolute left-0 text-white text-xs font-semibold pt-2 pointer-events-none">{this.formatTime(this.props.track.progress)}</span>
                <span className="absolute right-0 text-white text-xs font-semibold pt-2 pointer-events-none">{this.formatTime(this.props.track.duration)}</span>
              </div>
            </div>
          )
        }
        { this.props.tracks && this.isCollapsed() && (
          <ul className="w-full mt-2 mb-3" onClick={e => e.stopPropagation()}>
            { this.props.tracks.map((item, index) => (
              <Track
                key={`track-${index}`}
                current={this.props.current}
                track={item}
                song={this.props.index}
                index={index + 1}
                toggleListening={this.props.toggleListening}
              />
            )) }
          </ul>
        ) }
      </li>
    );
  }
}

Song.propTypes = {
  current: PropTypes.object.isRequired,
  index: PropTypes.number,
  progressBar: PropTypes.bool,
  toggleListening: PropTypes.func,
  onCollapse: PropTypes.func,
  setCurrentTime: PropTypes.func,
  children: PropTypes.array,
  track: PropTypes.object,
  tracks: PropTypes.array
};

Song.defaultProps = {
  collapsed: false,
  progressBar: true,
  listen: false,
  toggleListening: () => {},
  onCollapse: () => {},
  setCurrentTime: () => {}
};

export default Song;
